<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _ from 'lodash'
import BrokerDetail from '@/modules/broker/views/BrokerDetail.vue'
import {
  BrokerApprovalListActionTypes,
  useBrokerApprovalListStore
} from '@/modules/broker/stores/broker.approval.list.store.ts'
import { useReactiveQueryParam } from '@/composables/useReactiveQueryParam'
import { useBrokerDetailStore } from '../stores/broker.detail.store'


const router = useRouter()
const brokerApprovalListStore = useBrokerApprovalListStore()
const brokerDetailStore = useBrokerDetailStore()

const pageTabs = computed(() => {
  return brokerApprovalListStore.tabs
})
const displayTabContent = computed(() => {
  return brokerApprovalListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return brokerApprovalListStore.tableConfig
})
const filter = computed(() => {
  return brokerApprovalListStore.filter
})
const loading = computed(() => {
  return brokerApprovalListStore.action_type == BrokerApprovalListActionTypes.FETCHING
})
const page = computed(() => {
  return brokerApprovalListStore.page
})
const pageSize = computed(() => {
  return brokerApprovalListStore.pageSize
})
const dataSource = computed(() => {
  return brokerApprovalListStore.data
})

const handleChangeTab = (tab: any) => {

  brokerApprovalListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  brokerApprovalListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  brokerApprovalListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  brokerApprovalListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  brokerApprovalListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  brokerApprovalListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  brokerApprovalListStore.newTab({id: item.id, label: `#${item.code} - ${item.full_name}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {
  brokerApprovalListStore.toggleSort(field, direction)
}

const requestFetchAccountList = _.debounce(async () => {
  try{
    const res = await brokerApprovalListStore.fetchList()
  } catch (e) {

  }
}, 500)

const detailId: any = useReactiveQueryParam('detailId')
const setDetailTab = async () => {
  if(parseInt(detailId.value || 0)){
    try {
      const data: any = await brokerDetailStore.fetchBrokerDetail(parseInt(detailId.value))
      brokerApprovalListStore.newTab({id: data.id, label: `#${data?.user?.code} - ${data?.user?.full_name}`, active: true})
    } catch (e: any) {
      console.log(e)
    }
  }
}

watch(()=>detailId, (val) => {
  console.log('Giá trị detailId thay đổi:', val.value)
  if(val.value) setDetailTab()
}, {immediate: true})


watch(()=> brokerApprovalListStore.uuid, (newVal, oldVal) => {
  requestFetchAccountList()
})

onMounted(() => {
  // if(brokerApprovalListStore.action_type === BrokerApprovalListActionTypes.PENDING)
  brokerApprovalListStore.changeTab('list')
  requestFetchAccountList()
})
</script>

<template>
  <dashboard-layout currentRoute="broker/approval" page-title="Danh sách phê duyệt môi giới" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
        @reset:filter="brokerApprovalListStore.resetFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        :row-action-buttons="[
          { action: handleRowDblClick, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone', perm: 'broker.view_info' }
        ]"
        primaryField=""
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="brokerApprovalListStore.toggleColumnVisibility"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"

      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <BrokerDetail :id="tab.id" :key="tab.id"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
